import { DateField } from 'src/features/directory-form/entities/control-entities/date-field.entity';
import { TDirectoryTypeAttribute } from 'src/store/directories/types';

import { TDateRaw } from '../types';

export const mapDateItem = (item: TDateRaw, attribute: TDirectoryTypeAttribute | undefined) => {
  const dateProps = {
    formElementRefId: item.attrName,
    unit: attribute?.unit,
    fieldId: attribute?.name,
    enableIf: item.enableIf,
    label: attribute?.defaultLabel,
    showIf: item.showIf,
    defaultValueLink: item.defaultValueLink,
    restrictions: { required: !!attribute?.required, ...attribute?.restrictions },
    requiredIf: item.requiredIf,
    type: item.type,
  };

  return new DateField(dateProps);
};
